import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium drv-mb-1" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import CheckConnection from "../CheckConnection.vue";
import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  IWebfleetBasic,
  EAuthTypes,
  ECommonMessages,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";


export default /*@__PURE__*/_defineComponent({
  __name: 'WebfleetBasic',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit =
  __emit;

const icon = {
  name: "circle-information",
  size: 16,
};

const EMPTY_MODEL = {
  type: EAuthTypes.BASIC,
  username: "",
  password: "",
  accountName: "",
};

const isLoading = ref<boolean>(false);

const model = computed<IWebfleetBasic>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IWebfleetBasic) {
    emit("update:modelValue", value);
  },
});

const accountNameModel = computed<string>({
  get() {
    return props.modelValue?.accountName ?? EMPTY_MODEL.accountName;
  },
  set(value: string) {
    model.value = { ...model.value, accountName: value };
  },
});

const usernameModel = computed<string>({
  get() {
    return props.modelValue?.username ?? EMPTY_MODEL.username;
  },
  set(value: string) {
    model.value = { ...model.value, username: value };
  },
});

const passwordModel = computed<string>({
  get() {
    return props.modelValue?.password ?? EMPTY_MODEL.password;
  },
  set(value: string) {
    model.value = { ...model.value, password: value };
  },
});

const currentMethod = computed(() => {
  return props.platform.methods.find(
    (m) => m.authorityType === EAuthTypes.BASIC
  );
});
const url = computed<string>(() => {
  return currentMethod.value?.url ?? "https://csv.telematics.tomtom.com/extern";
});
const isConnectionValid = ref<boolean | null>(props.modelValue ? true : null);

const clearConnection = () => {
  emit("update:modelValue", {
    type: EAuthTypes.BASIC,
    username: "",
    password: "",
    accountName: "",
  } as IWebfleetBasic);
};

const nameControl = ref<typeof Input | null>(null);
const passwordControl = ref<typeof Input | null>(null);
const accountNameControl = ref<typeof Input | null>(null);

const hasFormError = computed<boolean>(() => {
  return (
    !usernameModel.value ||
    nameControl.value?.hasError ||
    !passwordModel.value ||
    passwordControl.value?.hasError ||
    !accountNameModel.value ||
    accountNameControl.value?.hasError
  );
});
const hasError = computed<boolean>(() => {
  return !isConnectionValid.value || hasFormError.value;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_icon_tooltip = _resolveComponent("d-icon-tooltip")!
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_password_input = _resolveComponent("d-password-input")!
  const _component_d_snackbar = _resolveComponent("d-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).WEBFLEET_BASIC_TITLE)), 1),
      _createElementVNode("div", {
        class: "drv-text-body-md drv-mb-4",
        innerHTML: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_BASIC_SUBTITLE)
      }, null, 8, _hoisted_3)
    ]),
    _createVNode(_component_d_input, {
      ref_key: "accountNameControl",
      ref: accountNameControl,
      class: "drv-form-control-adaptive",
      modelValue: accountNameModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountNameModel).value = $event)),
      disable: _ctx.disable,
      "lazy-rules": "",
      "label-slot": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, {
      label: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).WEBFLEET_BASIC_ACCOUNT_NAME_TITLE)), 1),
        _createVNode(_component_d_icon_tooltip, {
          icon: icon,
          class: "info-icon drv-ml-1 drv-color-b400",
          "tooltip-anchor": "top end",
          "tooltip-self": "top start"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              innerHTML: _ctx.$t(_unref(ETelematicsMessagesKeys).WEBFLEET_ACCOUNT_NAME_HINT)
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "disable", "rules"]),
    _createVNode(_component_d_input, {
      ref_key: "nameControl",
      ref: nameControl,
      modelValue: usernameModel.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((usernameModel).value = $event)),
      class: "drv-form-control-adaptive",
      disable: _ctx.disable,
      label: _ctx.$t(_unref(ETelematicsMessagesKeys).WEBFLEET_BASIC_USERNAME_TITLE),
      "lazy-rules": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, null, 8, ["modelValue", "disable", "label", "rules"]),
    _createVNode(_component_d_password_input, {
      ref_key: "passwordControl",
      ref: passwordControl,
      class: "drv-form-control-adaptive",
      dense: "",
      outlined: "",
      label: _ctx.$t(_unref(ETelematicsMessagesKeys).WEBFLEET_BASIC_PASSWORD_TITLE),
      modelValue: passwordModel.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordModel).value = $event)),
      disable: _ctx.disable,
      "lazy-rules": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, null, 8, ["label", "modelValue", "disable", "rules"]),
    _createVNode(CheckConnection, {
      class: "drv-py-2",
      modelValue: isConnectionValid.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isConnectionValid).value = $event)),
      loading: isLoading.value,
      "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((isLoading).value = $event)),
      "is-model-fullfiled": !hasFormError.value,
      "platform-type": _ctx.platform.const,
      url: url.value,
      creds: model.value,
      onClear: clearConnection
    }, null, 8, ["modelValue", "loading", "is-model-fullfiled", "platform-type", "url", "creds"]),
    _createVNode(_component_d_snackbar, {
      icon: "triangle-exclamation",
      class: "drv-bg-color-b100 drv-color-b600 drv-my-2",
      message: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_BASIC_INFO)
    }, null, 8, ["message"])
  ]))
}
}

})